"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFan = function SvgFan(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 1)",
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.05 17.14-.712 2.017a1 1 0 0 1-.57.595l-2.29.92c-.248.1-.41.34-.41.607 0 .244.197.442.441.442h10.275a.442.442 0 0 0 .442-.442.64.64 0 0 0-.413-.598l-2.476-.936a1 1 0 0 1-.586-.592l-.735-2.012"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18 7.357c-.201-.825-.588-1.375-1.161-1.649-.86-.411-1.577-1.057-1.577-2.094s.733-1.705 2.234-1.705c1.502 0 2.73 1.36 2.828 2.49.098 1.129-.113 1.82-.368 2.714m-.889 2.99c-.614.587-.896 1.197-.847 1.83.073.95-.128 1.894-1.026 2.413-.898.518-1.842.217-2.593-1.083-.75-1.3-.187-3.044.742-3.694.929-.65 1.632-.812 2.534-1.038m3.117-.16c.816.238 1.485.178 2.009-.181.786-.539 1.704-.837 2.602-.318.898.518 1.11 1.486.359 2.787-.751 1.3-2.543 1.683-3.57 1.204-1.027-.48-1.52-1.008-2.166-1.676"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFan);
var _default = Memo;
exports["default"] = _default;